import React from 'react';
import { Box, Typography } from '@mui/material';
import { resolveSlotValues, getDTWidgetSlots } from '../../registry/dtWidgetTypes';
import { useDTDemoMap } from '../../hooks/useDTDemoTick';
import { hasLiveSlotValue } from '../../utils/dtDemoFallback';
import { dtWidgetFilledColumnSx } from '../../styles/dtWidgetStyleTokens';

const DEFAULT_SLOTS = getDTWidgetSlots('dt-general-info');

function DTGeneralInfo({ widget, data, theme }) {
  const isDark = theme === 'dark';
  const tagprops = widget?.props?.extended?.tagprops || [];
  const liveData = Array.isArray(data) ? data : [];
  const slotValues = resolveSlotValues(tagprops, liveData);
  const demoMap = useDTDemoMap('dt-general-info');

  const fields = DEFAULT_SLOTS.map((slot) => {
    const resolved = slotValues[slot.key];
    const liveOk = hasLiveSlotValue(resolved);
    const demoVal = demoMap[slot.key];
    return {
      label: resolved?.alias || slot.label,
      value: liveOk ? resolved.value : demoVal ?? '—',
      unit: resolved?.unit || slot.unit,
    };
  });

  return (
    <Box sx={{ ...dtWidgetFilledColumnSx, px: 1 }}>
      <Typography variant="subtitle2" sx={{ color: isDark ? '#fff' : '#000', fontWeight: 700, mb: 0.5, flexShrink: 0 }}>
        General Info
      </Typography>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
        {fields.map(({ label, value, unit }) => (
          <Box key={label} sx={{ textAlign: 'center', px: 0.5 }}>
            <Typography variant="caption" sx={{ color: isDark ? '#aaa' : '#666', display: 'block' }}>
              {label}
            </Typography>
            <Typography variant="h6" sx={{ color: isDark ? '#fff' : '#000', fontWeight: 700 }}>
              {value !== '—' && value !== null ? `${value}${unit ? ` ${unit}` : ''}` : '—'}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default React.memo(DTGeneralInfo);
